var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { ui_grey20 } from 'Styles/colors';
import ResponsiveImage from '../../../ResponsiveImage/ResponsiveImage';
import { FADE_ANIMATION_DURATION } from '../../ProductCard.styled';
export var Image = styled(ResponsiveImage).attrs({
    background: ui_grey20,
    resolution: {
        small: 270,
        medium: 450,
        large: 525
    },
    crop: {
        height: 3520,
        width: 2640
    },
    cropType: 'crop',
    fetchFormat: null
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transition: opacity ", "ms ease-in;\n\n  &.fade-enter {\n    opacity: 0;\n  }\n\n  &.fade-enter-active {\n    opacity: 1;\n  }\n\n  /* Images are cross faded. When an image is transitioning out, put it behind the image that's transitioning in. */\n  &[class*='fade-exit'] {\n    position: absolute;\n    top: 0;\n    z-index: -1;\n  }\n\n  &.fade-exit {\n    opacity: 1;\n  }\n\n  &.fade-exit-active {\n    opacity: 0;\n  }\n"], ["\n  transition: opacity ", "ms ease-in;\n\n  &.fade-enter {\n    opacity: 0;\n  }\n\n  &.fade-enter-active {\n    opacity: 1;\n  }\n\n  /* Images are cross faded. When an image is transitioning out, put it behind the image that's transitioning in. */\n  &[class*='fade-exit'] {\n    position: absolute;\n    top: 0;\n    z-index: -1;\n  }\n\n  &.fade-exit {\n    opacity: 1;\n  }\n\n  &.fade-exit-active {\n    opacity: 0;\n  }\n"])), FADE_ANIMATION_DURATION);
export var ImageContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
export var VariantImageContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: ", ";\n  position: relative;\n"], ["\n  background-color: ", ";\n  position: relative;\n"])), ui_grey20);
var templateObject_1, templateObject_2, templateObject_3;
